import { createTheme, Shadows } from '@mui/material';

type OverridingShadowsType = {
  [P in keyof Shadows]?: Shadows[P];
};

const overridingShadows: OverridingShadowsType = {};

const customShadows = ['0px 4px 40px rgba(0, 0, 0, 0.05)'];

const defaultShadows = createTheme({}).shadows;

const shadows = defaultShadows
  .map((defaultShadow, index) =>
    overridingShadows[index] ? overridingShadows[index] : defaultShadow,
  )
  .concat(customShadows) as Shadows;

export { shadows };
